import { HttpClient } from '../../../httpClient'
import { queryString } from '../../../httpClient/queryString'
import {
  OpalApi,
  OpalApiRequestParams,
  OpalApiResponseDocument,
} from '../../../schema'

type ReadViewsV3 = OpalApi<'ReadViewsV3', 200>
type ReadViewV3Params = OpalApiRequestParams<'ReadViewV3'>
type ReadViewV3Response = OpalApiResponseDocument<'ReadViewV3', 200>

export const readView = async (
  params: ReadViewV3Params
): Promise<ReadViewV3Response> => {
  const viewId = params.path.view_id
  const url = new URL(`/loupe/v3/views/${viewId}`, window.location.origin)

  url.search = queryString({
    ...params.query,
  })

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}

export const readViews: ReadViewsV3 = async (args = {}) => {
  const url = new URL('/loupe/v3/views', window.location.origin)

  url.search = queryString(args.params?.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
